module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cb-Db-Ed-Gc.64b2c0c5.png";